import * as React from 'react';
import styled from 'styled-components';
import { FlexRowCenterVertical, TextP } from '../../..';
import { __ } from 'react-i18n';
import { Select } from '../General/Select';

interface Props {
  children: any;
  handleChange: any;
  sortValue: string;
}

function CategoryTopFilters({ children, handleChange, sortValue }: Props) {
  return (
    <Wrapper>
      <Select
        name="sort_by"
        label={''}
        value={sortValue}
        options={[
          { value: 'none', name: 'Na základe kódu produktu' },
          { value: 'price_asc', name: 'Od najlacnejšieho' },
          { value: 'price_desc', name: 'Od najdrahšieho' },
          { value: 'alphabetically_asc', name: 'Abecedne A-Z' },
          { value: 'alphabetically_desc', name: 'Abecedne Z-A' },
        ]}
        // tslint:disable-next-line:jsx-no-lambda
        onChange={handleChange}
        marginBottom={16}
        marginRight={0}
        mobileMarginBottom={16}
        mobileMarginRight={0}
      />
      {children}
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  width: 100%;
`;

export { CategoryTopFilters };
